import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px 6%;
  background-color: aliceblue;
  margin-bottom: 24px;
`;
